import { useEffect, useState } from "react";
import { Image } from "@fluentui/react-components";
import { getTokens } from "../helpers/sso-helper";
import writeDataToOfficeDocument from "../utils/localstorage";
import { useStyles } from "./style";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Office.onReady((info) => {
      if (info.host !== Office.HostType.PowerPoint) {
        setError("This add-in only works in PowerPoint");
      }
    });

    window.document.title = "AI Writing Assistant";
  }, []);

  const handleLogin = async () => {
    try {
      await getTokens(writeDataToOfficeDocument);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch user data");
    }
  };
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Image src={"assets/alpha-script-logo.png"} alt="Alpha Script Logo" className={styles.logo} />
        <Image
          id={"loginButton"}
          src={"assets/ms-sign-in.png"}
          alt="Sign in with Microsoft"
          onClick={handleLogin}
          className={styles.buttonSignin}
        />
      </div>
    </div>
  );
}
